import type { ApiPaths } from '@reos/api-client';
import { apiClient } from './api.js';
import { unwrap } from './api-error.js';

/**
 * Krok GPS1 — rozbaleni KRATKEHO ODKAZU Z MAPY (`goo.gl/…`, `mapy.cz/s/…`).
 *
 * Jde o `/v1/public/*`, ne o admin cestu: rozbaleni nedela zadna data tenanta
 * ani nepotrebuje hlaseni — je to ciste zadani souradnice z verejne mapy. Je
 * tu i proto, ze admin chce pouzit stejnou sluzbu co verejny web (jinak by
 * mel dva rozbalovace a dva seznamy hostu, ktere by se casem rozchazily).
 *
 * ROZHODNUTI GPS1: rozbaleni NEJDE v prohlizeci. Prohlizec by sahal na cizi
 * host zpusobem, ktery nejde vypnout v CSP, a ktery by unikal cookies
 * jineho webu. Server navíc vynucuje https, povolene hosty, timeout a limit
 * presmerovani (viz `resolveShortMapLink` v `@reos/geo-input`).
 */

export type MapLinkDto =
  ApiPaths['/v1/public/map-link']['get']['responses']['200']['content']['application/json'];

/**
 * `UNAVAILABLE` NENI chyba a nejde na ni vyhodit: znamena, že se krátký
 * odkaz neda rozbalit (expiroval, prilis dlouhy retezec presmerovani,
 * timeout). Volajici spadne zpet na rucni zadani — jinak by uzivatel kvůli
 * expirovanému krátkému odkazu nemohl založit zakázku, i když umí napsat
 * souradnici.
 */
export async function fetchMapLink(url: string): Promise<MapLinkDto> {
  return unwrap(apiClient.GET('/v1/public/map-link', { params: { query: { url } } }));
}
